export default "__VITE_ASSET__CPPvBMsB__"